<ion-toolbar mode="md">
  <div slot="start" class="segment-wrapper" *ngIf="!searchBarShow; else searchBarView">
    <ion-segment mode="md" (ionChange)="onChanged($event)" [value]="active">
      <ion-segment-button *ngFor="let item of options" [value]="item">
        <ion-label>{{ item }}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>
  <ng-template #searchBarView>
    <ion-searchbar
      placeholder="Search by name"
      mode="md"
      [(ngModel)]="search"
      (ionInput)="searching.emit($event.detail.value)"
    ></ion-searchbar>
  </ng-template>

  <ion-buttons slot="end">
    <ion-button size="large" class="search-btn" (click)="showSearchBar()">
      <ion-icon
        *ngIf="!searchBarShow"
        name="search-outline"
        slot="icon-only"
      ></ion-icon>
      <ion-icon *ngIf="searchBarShow" name="close" slot="icon-only"></ion-icon>
    </ion-button>
  </ion-buttons>
</ion-toolbar>
